import React, { useRef, useEffect } from 'react';
import OvalSpinner from '../Spinners/OvalSpinner';
import { SiGmail } from 'react-icons/si';
import axios from 'axios';
import Checkbox from '@mui/material/Checkbox';
import { ThreeCircles } from 'react-loader-spinner';
import StartPillButton from '../Buttons/StartPillButton';
import {
    ImageAltStyled,
    JobCardStyled,
    JobListStyled,
    OverflowContainerStyled,
    RuleStyled
} from "../../../styled/JobConnection";
import { FaBuilding } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";

import {useTheme} from "../Theme/ThemeContext";
import PillBadge from '../Badge/PillBadge';

const styles = {
    cardGrid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '10px auto'
    }
};

const JobList = ({ data, jobClick, onJobClick, loadingJobs, jobListRef, multiApplyMode=false, processingActive=false, selectedJobIds=[], onToggleJobSelect, onBlockedSelection, maxSelectable=5, onStart, startPending=false, gmailGranted=false, gmailIsGmail=false, onDisconnectGmail, disconnectPending=false }) => {
    const {themeName} = useTheme();
    const brandColor = '#3E8F93';
    const borderColor = (themeName || '').toLowerCase().includes('dark') ? '#ffffff' : brandColor;
    const jobListGmailPopupRef = useRef(null);
    const jobListGmailPopupCheckRef = useRef(null);

    useEffect(() => {
        return () => {
            try { if (jobListGmailPopupCheckRef.current) { clearInterval(jobListGmailPopupCheckRef.current); jobListGmailPopupCheckRef.current = null; } } catch(_) {}
            try { jobListGmailPopupRef.current = null; } catch(_) {}
        };
    }, []);

    return (
        <JobListStyled theme={themeName}>
            <div style={{display:'flex', flexWrap:'wrap', alignItems:'center', gap: '0.5rem'}}>
                <h1 className="sectionTitle" style={{margin:0}}>Connection List</h1>
                <div style={{ marginLeft:'auto', display:'inline-flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                    {multiApplyMode && !processingActive && (
                        <span style={{ display:'inline-flex', alignItems:'center', gap:6, border:'1px solid #5fbec5', color:'#5fbec5', padding:'2px 8px', borderRadius:'999px', fontSize:'.75rem' }}>
                            {selectedJobIds.length}/{maxSelectable}
                        </span>
                    )}
                    {gmailIsGmail && (multiApplyMode || processingActive) && (
                        <div style={{ display:'inline-flex', alignItems:'center', gap:8 }}>
                            {gmailGranted ? (
                                <span title="Gmail connected" style={{ display:'inline-flex', alignItems:'center', gap:6, border:'1px dashed #5fbec5', color:'#5fbec5', padding:'2px 8px', borderRadius: '999px', fontSize:'.75rem' }}>
                                    <SiGmail size={14} /> Connected
                                    <button onClick={!disconnectPending ? onDisconnectGmail : undefined} style={{ marginLeft:8, border:'none', background:'transparent', color:'#EA4335', cursor: disconnectPending ? 'wait' : 'pointer', fontSize:'.75rem', textDecoration: disconnectPending ? 'none' : 'underline', display:'inline-flex', alignItems:'center', gap:6 }}>
                                        {disconnectPending ? (<OvalSpinner size={12} color="#EA4335" />) : 'Disconnect'}
                                    </button>
                                </span>
                            ) : (
                                <span title="Gmail not connected" style={{ display:'inline-flex', alignItems:'center', gap:6, border:'1px dashed #999', color:'#666', padding:'2px 8px', borderRadius: '999px', fontSize:'.75rem' }}>
                                    <SiGmail size={14} /> Not connected
                                    <button onClick={async () => {
                                        try {
                                            const token = localStorage.getItem('token');
                                            const s = await axios.get('/user/gmail/oauth/start?mode=popup', { headers: { 'x-access-token': token }});
                                            const gmailAuthUrl = s?.data?.authUrl;
                                            if (gmailAuthUrl) {
                                                const w = 720, h = 700;
                                                const x = Math.max(0, Math.floor((window.screen.availWidth - w) / 2));
                                                const y = Math.max(0, Math.floor((window.screen.availHeight - h) / 2));
                                                const win = window.open(gmailAuthUrl, 'gmail-oauth', `width=${w},height=${h},left=${x},top=${y},resizable=yes,scrollbars=yes,status=yes`);
                                                try { jobListGmailPopupRef.current = win; } catch(_) {}
                                                if (!win) window.location.href = gmailAuthUrl;
                                                // start poll fallback to detect popup close and refresh gmail status
                                                try {
                                                    if (jobListGmailPopupCheckRef.current) clearInterval(jobListGmailPopupCheckRef.current);
                                                    jobListGmailPopupCheckRef.current = setInterval(async () => {
                                                        try {
                                                            if (!jobListGmailPopupRef.current || jobListGmailPopupRef.current.closed) {
                                                                clearInterval(jobListGmailPopupCheckRef.current);
                                                                jobListGmailPopupCheckRef.current = null;
                                                                const token2 = localStorage.getItem('token');
                                                                const r = await axios.get('/user/gmail/permission-status', { headers: { 'x-access-token': token2 }});
                                                                const granted = !!r?.data?.granted;
                                                                if (granted) {
                                                                    try { window.dispatchEvent(new CustomEvent('gmail_connected')); } catch(_) {}
                                                                }
                                                            }
                                                        } catch(_) {}
                                                    }, 800);
                                                } catch(_) {}
                                            } else {
                                                // fallback: navigate to job hub where user can connect
                                                window.location.href = '/user/dashboard/auto-apply';
                                            }
                                        } catch (e) {
                                            try { window.location.href = '/user/dashboard/auto-apply'; } catch(_){ }
                                        }
                                    }} style={{ marginLeft:8, border:'none', background:'transparent', color:'#3E8F93', cursor: 'pointer', fontSize:'.75rem', textDecoration: 'underline', display:'inline-flex', alignItems:'center', gap:6 }}>
                                        Connect
                                    </button>
                                </span>
                            )}
                        </div>
                    )}
                    {multiApplyMode && (
                        <StartPillButton onClick={() => onStart && onStart()} disabled={startPending} pending={startPending}>
                          Start
                        </StartPillButton>
                    )}
                </div>
            </div>
            <RuleStyled/>
            {multiApplyMode && (
                <p style={{color: '#fff', background:'#3E8F93', padding: '6px 10px', borderRadius: '6px', fontSize: '0.75rem', marginTop: 0}}>
                    Pick the jobs you want Bubble Ai to apply to and click Start (max {maxSelectable} jobs).
                </p>
            )}

            <OverflowContainerStyled ref={jobListRef}>
                {data && data.map((job, index) => {
                    const compositeKey = [
                        job?.id,
                        job?.url,
                        job?.job_title || job?.title,
                        job?.company_name || job?.company
                    ].filter(Boolean).join('::') || String(index);
                    const id = job?.id || job?.url || `${job?.title || job?.job_title}-${job?.company_name || job?.company}`;
                    const checked = selectedJobIds.includes(id);
                    const isAttempted = Boolean(job?.attemptedEmailAutoApply);
                    // treat attemptedEmailAutoApply as a blocked state in UI (same as applied)
                    const isApplied = Boolean(job?.applied || isAttempted);
                    const handleClick = () => {
                        if (multiApplyMode) {
                            if (isApplied) {
                                onBlockedSelection && onBlockedSelection(job);
                                return; // block selection for already-applied or attempted jobs
                            }
                            onToggleJobSelect && onToggleJobSelect(job);
                        } else {
                            onJobClick(index);
                        }
                    };
                    return (
                    <JobCardStyled
                        theme={themeName}
                        key={compositeKey}
                        onClick={handleClick}
                        active={jobClick === index}
                        className="jobCard"
                        isApplied={isApplied && multiApplyMode}
                    >
                        {multiApplyMode && (
                            <label className="custom-checkbox" onClick={(e) => e.stopPropagation()} style={{display:'inline-flex', alignItems:'center'}}>
                                <Checkbox
                                    size="small"
                                    checked={checked}
                                    disabled={isApplied}
                                    onChange={(e) => { 
                                        e.stopPropagation(); 
                                        if (isApplied) { onBlockedSelection && onBlockedSelection(job); return; }
                                        onToggleJobSelect && onToggleJobSelect(job); 
                                    }}
                                    inputProps={{ 'aria-label': 'Select job' }}
                                    sx={{ p: 0, mr: 1 }}
                                    icon={
                                        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                                            <rect x="3" y="3" width="18" height="18" rx="3" ry="3" fill="transparent" stroke={borderColor} strokeWidth="2" />
                                        </svg>
                                    }
                                    checkedIcon={
                                        <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                                            <rect x="3" y="3" width="18" height="18" rx="3" ry="3" fill={brandColor} stroke={borderColor} strokeWidth="2" />
                                            <polyline points="7,13 11,17 17,8" fill="none" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    }
                                />
                            </label>
                        )}
                        <ImageAltStyled theme={themeName}>
                            {(job?.company_object?.logo || job?.company_logo) ? (
                                <img
                                    src={job?.company_logo || job.company_object?.logo}
                                    alt={job?.company_name || job?.company || "Company Logo"}
                                />
                            ) : (
                                <h1>{job?.company_name?.charAt(0) || job?.company?.charAt(0)}</h1>
                            )}
                        </ImageAltStyled>

                        <span className="content">
                                <h1>{job?.title || job?.job_title}</h1>
                                <p><FaBuilding color="#0C1E28" /> <span>{job.company_name || job?.company}</span></p>
                            {(job.location || job?.country) && <p><IoLocationSharp color="#0C1E28"/> <span>{job.location || job?.country}</span></p>}
                        </span>
                        {/* badge placed below content so it does not overlap */}
                        {(job?.applied || job?.attemptedEmailAutoApply) && (
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                                <PillBadge
                                    label={job?.applied ? 'Applied' : 'Attempted'}
                                    variant={job?.applied ? 'applied' : 'attempted'}
                                    theme={themeName}
                                    compact={true}
                                />
                            </div>
                        )}
                    </JobCardStyled>
                )})}

                {loadingJobs && (
                    <div style={{height: '100px', ...styles.cardGrid}}>
                        <ThreeCircles
                            height="30"
                            width="30"
                            innerCircleColor="#F8E231"
                            middleCircleColor="#987070"
                            outerCircleColor="#7CC9CC"
                            wrapperClass=""
                            visible={true}
                            ariaLabel="three-circles-rotating"
                        />
                    </div>
                )}
            </OverflowContainerStyled>

        </JobListStyled>

    );

}

export default JobList;